export var MCCivilstatusLmlStrings = {
    "ID_103": "0=Séparé\n1=Feitelijk gescheiden\n",
    "ID_106": "0=Cohabitant légal\n1=Wettelijk samenwonend\n",
    "ID_101": "0=Célibataire\n1=Ongehuwd\n",
    "ID_102": "0=Marié\n1=Gehuwd\n",
    "ID_104": "0=Divorcé\n1=Gescheiden\n",
    "ID_105": "0=Veuf\n1=Weduwnaar/Weduwe\n"
};
